<template>
  <v-dialog v-model="loadingDialog" persistent width="300">
    <v-card color="#4fb14e" dark style="border-radius: 16px !important;">
      <v-card-text class="white--text">
        Loading Please Wait...
        <v-progress-linear
          indeterminate
          color="#ffffff"
          class="mb-0"
        ></v-progress-linear>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    show_loading: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    loadingDialog() {
      return this.show_loading;
    }
  }
};
</script>

<style scoped>
::v-deep .v-dialog {
  box-shadow: unset;
  border-radius: 16px;
}
</style>
